<template>
  <div>
    {{ team.teamName || "" }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      requestedTeamId: null,
    };
  },
  props: ["id"],
  computed: {
    team() {
      return this.$store.getters["teams/byId"](this.id) || {};
    },
  },
  watch: {
    id: {
      immediate: true,
      handler(teamId) {
        this.ensureTeamLoaded(teamId);
      },
    },
  },
  methods: {
    ensureTeamLoaded(teamId) {
      if (teamId == null || teamId === "") return;
      const id = String(teamId);
      if (this.$store.getters["teams/byId"](id)) return;
      if (this.requestedTeamId === id) return;
      this.requestedTeamId = id;
      this.$store.dispatch("teams/fetchById", id).catch(() => {});
    },
  },
};
</script>

<style scoped>
/* 
.card{
  position: inherit;
} */
</style>
